import { AbbreviatedNumber, FormattedNumber } from '@futrli/localisation';
import React from 'react';

import { CURRENCY_DECIMAL_PLACES } from '../../../core/constants';
import { penceToAmount } from '../../../core/formatters';

interface Props {
  amount: number;
  maxDigits: number;
  hideDecimals?: boolean;
}

export const FormattedAmount: React.FC<Props> = ({ amount, maxDigits, hideDecimals }) => {
  const poundsAmount = penceToAmount(amount);

  if (amount.toString().length > maxDigits) {
    return <AbbreviatedNumber style="currency" currency="" value={poundsAmount} maxDigits={maxDigits} />;
  }

  if (hideDecimals) {
    return (
      <FormattedNumber
        style="decimal"
        value={Math.round(poundsAmount)}
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      />
    );
  }
  return (
    <FormattedNumber
      style="decimal"
      value={poundsAmount}
      maximumFractionDigits={CURRENCY_DECIMAL_PLACES}
      minimumFractionDigits={CURRENCY_DECIMAL_PLACES}
    />
  );
};
